export default __webpack_public_path__ + "static/media/decada-0080-0001-min.dd21bafc.jpg";